import { createStyles } from 'antd-style';

export const useFontAwesomeAdaptersStyles = createStyles(() => ({
  disabledFaIcon: {
    opacity: 0.5,
  },
}));
